import { render, staticRenderFns } from "./attestation.vue?vue&type=template&id=cbc18e1a&scoped=true"
import script from "./attestation.vue?vue&type=script&lang=js"
export * from "./attestation.vue?vue&type=script&lang=js"
import style0 from "./attestation.vue?vue&type=style&index=0&id=cbc18e1a&prod&lang=scss&scoped=true"
import style1 from "./attestation.vue?vue&type=style&index=1&id=cbc18e1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc18e1a",
  null
  
)

export default component.exports